import {CostDetailItemResponseBody, CostItem} from '@dms/api/core';

export const getCostItemsFromPreset = (presetItems?: CostDetailItemResponseBody[]): CostItem[] =>
  presetItems?.map((presetItem) => ({
    ...presetItem,
    cost: (presetItem.cost ?? 0).toString(),
    currency: presetItem.currency ?? 'CZK',
    note: presetItem.note ?? '',
  })) ?? [];
